import React, { useState } from "react";
import LayoutHOC from "../LayoutHOC";
import Input from "../UniversalComponents/InputComponent";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ReactComponent as CalendarWithTimeIcon } from "../../assets/images/calendarWithTimeIcon.svg";
import Button from "../UniversalComponents/DefaultButton";
import TableComponent from "../UniversalComponents/TableComponent";
const JournalEntry = () => {
  const [journalDate, setJournalDate] = useState("");
  const [journalNo, setJournalNo] = useState("");

  const handleJournalDate = (date) => {
    setJournalDate(date);
  };

  const handleJournalNo = (e) => {
    setJournalNo(e.target.value);
  };

  return (
    <div className="mx-5 mt-10">
      <div>
        <h5 className="text-1D4469 text-18 font-600 py-2">Journal Entry</h5>
      </div>
      <div className="bg-white border rounded p-2">
        <div className="flex space-x-2  w-1/2">
          <div className="w-full">
            <label className="w-full text-14 text-434852 font-400 pb-1 ">Journal Date</label>
            <div className="w-full">
              <div className="flex items-center bg-white datePicker_container rounded">
                <DatePicker
                  selected={journalDate}
                  onChange={handleJournalDate}
                  placeholderText={""}
                  dateFormat={"DD/MM/YYYY"}
                  className="bg-white border-[#DFE2E5]  w-[100%]   text-gray-800 text-sm block h-[35px] rounded "
                ></DatePicker>

                <div>
                  <CalendarWithTimeIcon></CalendarWithTimeIcon>
                </div>
              </div>
            </div>
          </div>

          <div className="w-full">
            <label className=" text-14 text-434852 font-400 pb-1 ">Journal no.</label>
            <Input
              placeholder="Enter Journal no."
              name="Journal no."
              value={journalNo}
              onChange={handleJournalNo}
              style={{ width: "100%", height: "35px", padding: "5px" }}
            />
            <div className="space-x-1">
              <input
                type="checkbox"
                className="appearance-none  text-12 focus:outline-none focus:ring-0 checked:bg-blue-500 checked:border-transparent border-[#D9D9D9]"
                style={{ boxShadow: "none" }}
              />

              <span className="text-[#2C495D] text-12 ">Is Adjusting Journal Entry</span>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-4">
        <TableComponent name="categoryDetails" />
      </div>
      <div className="   border bg-white p-4 border-[#D6D3D3] mt-4 rounded">
        <div className="flex gap-4 w-[60%]">
          <div className="w-full">
            <label className="text-434852 font-400 text-14">Memo</label>
            <div className="border border-[#D6D3D3] h-28 rounded-md"></div>
          </div>
          <div className="w-full">
            <label className="flex justify-between">
              <label className="text-14 text-434852 font-400 pb-1 ">
                <span className="font-600">Attachments(0)</span> Maximum Size 20 MB
              </label>
            </label>
            <div className="flex items-center justify-center rounded-md border-[#DFE2E5] border h-[120px] w-[100%]">
              <div className="flex flex-col items-center">
                <label className="text-[#AFAFAF] text-12 font-400 text-center">
                  Drop files here or click to select from the device
                </label>
                <div className="text-12 p-2 bg-gray-200 border rounded text-[11px] font-500">
                  Upload from this device{" "}
                </div>
              </div>
            </div>
            <label className=" text-12 text-[#009CBF] font-400 pb-1 pe-1">Show existing</label>
          </div>
        </div>
      </div>
      <div className="flex justify-end w-full mt-4">
        <div className="border bg-[#F6FEFF] h-full w-1/4">
          <div className=" my-2 text-12">
            <div className=" border-b p-2">
              <div className="flex justify-between  items-center px-4">
                <label className="text-1D4469   font-400">Total Debit</label>
                <span className="text-383838 font-500">$ 800.00</span>
              </div>
            </div>
            <div className=" p-2 border-b">
              <div className="flex justify-between  items-center px-4">
                <label className="text-1D4469   font-400">Total Credit</label>
                <span className="text-383838 font-500">$ 1600.00</span>
              </div>
            </div>
            <div className=" p-2">
              <div className="flex justify-between  items-center px-4">
                <label className="text-[#1D4469] text-12 font-700">Total Difference</label>
                <span className="text-383838 font-500">$ 800.00</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex justify-between py-3 items-center mb-20 ">
        <div className="">
          {/* <ul className="flex space-x-3  text-[#009CBF] text-12 font-400">
            {optionData.map((option) => (
              <li key={option}>{option}</li>
            ))}
          </ul> */}
        </div>

        <div className="flex  space-x-2 ">
          <Button type="primary" onClick={""} style={{ color: "#535252", height: "35px" }}>
            CANCEL
          </Button>
          <Button type="secondary" onClick={""} style={{ height: "35px" }}>
            SAVE
          </Button>
        </div>
      </div>
    </div>
  );
};

export default LayoutHOC(JournalEntry);
